import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoWhatsApp = () => {
  return (
    <g>
      <path d="m8.1135.16a7.6428 7.6428 0 0 0 -7.6428 7.6428 8.8145 8.8145 0 0 0 1.1093 3.9672l-1.3363 4.07 4.1878-1.3383a7.7472 7.7472 0 0 0 3.682.9438 7.6428 7.6428 0 1 0 0-15.2855zm0 14.0628a7.0167 7.0167 0 0 1 -3.5381-1.0621l-2.4139.7877.7833-2.3371a7.2986 7.2986 0 0 1 -1.2512-3.8085 6.42 6.42 0 1 1 6.42 6.42z" />
      <path d="m11.87 9.419s-1.2522-.6065-1.51-.7242a.3.3 0 0 0 -.3883.0742s-.38.48-.5018.637-.1919.2967-.51.192a4.9275 4.9275 0 0 1 -1.4791-.9163 6.1161 6.1161 0 0 1 -1.0341-1.274.2356.2356 0 0 1 .0175-.3055s.3306-.3807.4887-.5847a.503.503 0 0 0 .0219-.5236c-.0378-.092-.5454-1.2847-.62-1.4529a.3423.3423 0 0 0 -.2356-.1964h-.6019a.8961.8961 0 0 0 -.3141.1309 2.1144 2.1144 0 0 0 -.7416 1.52 2.5162 2.5162 0 0 0 .29 1.3361 9.6893 9.6893 0 0 0 2.11 2.6 7.3472 7.3472 0 0 0 2.9535 1.442 2.2844 2.2844 0 0 0 1.876-.5889 1.3689 1.3689 0 0 0 .34-1.1692.2035.2035 0 0 0 -.1611-.1965z" />
    </g>
  );
};

export default withIcon(IconLogoWhatsApp);
